import { subjectFactory } from "@taterer/rx-entity"

export const [setModal$, setModal] = subjectFactory<Element | undefined>()
